@if (user) {
  <div
    class="mb-2 gap-2"
  [class]="
    (user?.activeDevice?.info?.associatedPhone && !user.phoneRapidSynced) ||
    !user.rapidSynced
      ? 'd-flex justify-content-between align-items-center'
      : 'text-end '
  "
    >
    <!-- <div
    class="warning-badge me-1"
    *ngIf="
      (user?.activeDevice?.info?.associatedPhone && !user.phoneRapidSynced) ||
      !user.rapidSynced
    "
    >
    <div class="d-flex">
      <i class="fas fa-info-circle text-warning"></i>
      <small
        >The Phone Number and Account Number has not been synchronized with
        Rapid Web. Please synchronize your information as highlighted below. If
        you continue to see this message, please contact the
        administrator.</small
        >
      </div>
    </div> -->
    <div class="d-flex float-right gap-2">
      @if (user?.emergencyCadence && !isLoggedInEndUser) {
        <button
          type="button"
          class="btn btn-primary"
          style="min-width: 180px"
          (click)="onRemoveCadence()"
          [disabled]="isLoading.removeEmergencyCadence"
          >
          @if (isLoading.removeEmergencyCadence) {
            <span
              class="spinner-grow spinner-grow-sm ms-1"
              role="status"
              aria-hidden="true"
              ></span
              >
              }Remove Cadence
            </button>
          }
          <button
            type="button"
            class="btn btn-outline-primary"
            style="white-space: nowrap"
            (click)="endUserProfileInformationComponent.onOpenSidenav()"
            >
            Profile Information
          </button>
          @if (!isLoggedInEndUser) {
          <button
            type="button"
            class="btn btn-primary"
            (click)="notesComponent.onOpenNotes()"
            >
            Notes
          </button>
          }
        </div>
      </div>
    }

    <app-end-user-profile-information [data]="user"></app-end-user-profile-information>

    <app-threat-pair-alert-log #threatPairAlertLog></app-threat-pair-alert-log>

    <app-notes
      [isFetchingNotes]="isLoading.notes"
      [data]="notes"
      [notedUserId]="userId"
    ></app-notes>

    <div class="card mb-3">
      <!-- [style.height]="'238px'" -->
      <div class="card-body p-2">
        <div class="row w-100 m-0 p-0 display-flex justify-content-between">
          @if (user) {
            <div class="col-sm-12 col-xs-12 col-lg-1 px-0">
              <span
                class="nav-link avatar avatar-lg p-0 bg-primary-dark text-center text-white fw-bold"
                >
                {{ userInitials }}
              </span>
            </div>
            <div class="col-sm-12 col-xs-12 col-lg-3 p-0">
              <div class="d-flex flex-column">
                <div class="row gx-2 mb-1">
                  <div class="col-3 text-end">Name</div>
                  <div class="col-9">
                    <span
                      class="fw-bold cursor-pointer"
                      [mdbTooltip]="user?.demographic?.fullName"
                      >{{ user?.demographic?.fullName | trim : 20 : useTrim }}</span
                      >
                    </div>
                  </div>
                  <div class="row gx-2 mb-1">
                    <div class="col-3 text-end">DOB</div>
                    <div class="col-9">
                      <span class="fw-bold">{{ user?.demographic?.dob }}</span>
                    </div>
                  </div>
                  <div class="row gx-2 mb-1">
                    <div class="col-3 text-end">Email</div>
                    <div class="col-9">
                      <span
                        class="fw-bold cursor-pointer"
                        [mdbTooltip]="user?.demographic?.email"
                        >{{ user?.demographic?.email | trim : 20 : useTrim }}</span
                        >
                      </div>
                    </div>
                    <div class="row gx-2 mb-1">
                      <div class="col-3 text-end">Mobile</div>
                      <div class="col-9">
                        <span class="fw-bold" *ngIf="user?.demographic?.phone">{{
                          user?.demographic?.phone.length === 10
                          ? (user?.demographic?.phone | formatPhoneNumber)
                          : user?.demographic?.phone
                        }}</span>
                      </div>
                    </div>
                    <div class="row gx-2 mb-1">
                      <div class="col-3 text-end">Address</div>
                      <div class="col-9">
                        <span class="fw-bold"
                          >{{ user?.demographic?.address?.home?.addressLine1 }}
                          {{ user?.demographic?.address?.home?.addressLine2 }}</span
                          ><br />
                          <span class="fw-bold"
                            >{{
                            user?.demographic?.address?.home?.city +
                            ", " +
                            user?.demographic?.address?.home?.state +
                            " " +
                            user?.demographic?.address?.home?.zip
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-xs-12 col-lg-3 p-0">
                    <div class="d-flex flex-column">
                      <div class="row gx-2 mb-1">
                        <div class="col-3 col-lg-5 text-end">Status</div>
                        <div class="col-9 col-lg-7">
                          <span
                            class="fw-bold badge rounded-pill bg-opacity-25"
                  [ngClass]="{
                    'bg-primary text-primary':
                      user?.status?.toLowerCase() === userStatus.NEW,
                    'bg-success-light text-success':
                      user?.status?.toLowerCase() === userStatus.ACTIVATED,
                    'bg-warning text-warning':
                      user?.status?.toLowerCase() === userStatus.IN_PROGRESS
                  }"
                            >{{ user?.status }}</span
                            >
                          </div>
                        </div>
                        <div class="row gx-2 mb-1">
                          <div class="col-3 col-lg-5 text-end">Device Name</div>
                          <div class="col-9 col-lg-7">
                            <span
                              class="fw-bold cursor-pointer"
                              [mdbTooltip]="user?.activeDevice?.info?.name"
                              >{{
                              user?.activeDevice?.info?.name | trim : 15 : useTrim
                              }}</span
                              >
                            </div>
                          </div>
                          <div class="row gx-2 mb-1">
                            <div class="col-3 col-lg-5 text-end">Associated Phone</div>
                            <div class="col-9 col-lg-7">
                              <span class="fw-bold">{{
                                user?.activeDevice?.info?.associatedPhone?.length === 10
                                ? (user?.activeDevice?.info?.associatedPhone
                                | formatPhoneNumber)
                                : user?.activeDevice?.info?.associatedPhone
                              }}</span>
                              <!-- <i
                  *ngIf="
                    user?.activeDevice?.info?.associatedPhone &&
                    !user?.phoneRapidSynced &&
                    !isLoading.syncAssociatedPhoneNumber
                  "
                              class="fas fa-sync ms-1 text-danger"
                              style="cursor: pointer"
                              [mdbTooltip]="'Sync with Rapid Web'"
                              (click)="onSyncAssociatedPhoneInRapid()"
                            ></i> -->
                            @if (isLoading.syncAssociatedPhoneNumber) {
                              <span
                                class="spinner-grow spinner-grow-sm ms-1"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            }
                          </div>
                        </div>
                        <div class="row gx-2 mb-1">
                          <div class="col-3 col-lg-5 text-end">Model/Serial No.</div>
                          <div class="col-9 col-lg-7">
                            <span
                              class="fw-bold cursor-pointer"
                              [mdbTooltip]="user?.activeDevice?.info?.modelAndSerialNumber"
                              >{{
                              user?.activeDevice?.info?.modelAndSerialNumber
                              | trim : 15 : useTrim
                              }}</span
                              >
                            </div>
                          </div>
                          <div class="row gx-2 mb-1">
                            <div class="col-3 col-lg-5 text-end">IMEI</div>
                            <div class="col-9 col-lg-7">
                              <span class="fw-bold">{{
                                user?.activeDevice?.info?.imeiNumber ||
                                user?.activeDevice?.info?.eidNumber
                              }}</span>
                            </div>
                          </div>
                          <div class="row gx-2 mb-1">
                            <div class="col-3 col-lg-5 text-end">Watch App Version</div>
                            <div class="col-9 col-lg-7">
                              <span class="fw-bold">{{
                                user?.activeDevice.info.appVersionName ?? "N/A"
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-lg-3 p-0 border-start">
                        @if (!isLoggedInEndUser) {
                        <div>
                          <div class="mb-2">
                            <ul
                              class="d-flex justify-content-between"
                              style="list-style-type: none"
                              >
                              <li>
                                <button
                                  class="btn btn-link btn-sm py-0"
                                  [disabled]="isLoading.gpsCheck"
                                  (click)="onGpsCheck()"
                                  >
                                  Check GPS
                                </button>
                              </li>
                              <li>
                                <button
                                  class="btn btn-link btn-sm py-0"
                                  [disabled]="isLoading.networkCheck"
                                  (click)="onNetworkCheck()"
                                  >
                                  Check Network
                                </button>
                              </li>
                              <li>
                                <button
                                  class="btn btn-link btn-sm py-0"
                                  (click)="onDownloadLogs()"
                                  >
                                  Download Logs
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div class="row gx-2 mb-1">
                            <div class="col-3 text-end">GPS</div>
                            <div class="col-9 d-flex align-items-center">
                              @if (!isLoading.gpsCheck) {
                                <div>
                                  @if (device.gps.status) {
                                    <span
                                      class="fw-bold badge rounded-pill bg-opacity-25 mb-1"
                    [ngClass]="{
                      'bg-success-light text-success':
                        device.gps.status === 'Available',
                      'bg-danger text-danger':
                        device.gps.status === 'Not Available',
                      'text-black': device.gps.status === 'N/A'
                    }"
                                      >{{ device.gps.status }}</span
                                      >
                                      }<br />
                                      @if (device.gps.status !== 'N/A') {
                                        <span
                                          style="font-size: 11px"
                                          >{{ device.gps.date }}</span
                                          >
                                        }
                                      </div>
                                    }
                                    @if (isLoading.gpsCheck) {
                                      <span
                                        class="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    }
                                  </div>
                                </div>
                                <div class="row gx-2 mb-1">
                                  <div class="col-3 text-end">Network</div>
                                  <div class="col-9 d-flex align-items-center">
                                    @if (!isLoading.networkCheck) {
                                      <div>
                                        @if (device.network.status) {
                                          <span
                                            class="fw-bold badge rounded-pill bg-opacity-25 mb-1"
                    [ngClass]="{
                      'bg-success-light text-success':
                        device.network.status === 'Connected',
                      'bg-danger text-danger':
                        device.network.status === 'Not Connected',
                      'text-black': device.network.status === 'N/A'
                    }"
                                            >{{ device.network.status }}</span
                                            >
                                            }<br />
                                            @if (device.network.date !== 'N/A') {
                                              <span
                                                style="font-size: 11px"
                                                >{{ device.network.date }}</span
                                                >
                                              }
                                            </div>
                                          }
                                          @if (isLoading.networkCheck) {
                                            <span
                                              class="spinner-grow spinner-grow-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    }
                                  </div>
                                  <div
                                    class="col-xs-12 col-sm-6 col-lg-1 d-flex align-items-center flex-wrap justify-content-end p-0"
                                    >
                                    <img
                                      style="width: 125px"
            [src]="
              user.watchAppVersion == 1
                ? '../../../assets/img/png/watch-analog.png'
                : '../../../assets/img/png/watch-digital.png'
            "
                                      class="watch"
                                      />
                                  </div>
                                } @else {
                                  <div class="col-sm-12 col-xs-12 col-lg-1 px-0">
                                    <span class="">
                                      <app-skeleton-loader [config]="skeletonTheme"></app-skeleton-loader>
                                    </span>
                                  </div>
                                  <div class="col-sm-12 col-xs-12 col-lg-4 p-0">
                                    <div class="d-flex flex-column">
                                      <div class="row gx-2 mb-1">
                                        <div class="col-3 text-end">Name</div>
                                        <div class="col-9">
                                          <span class="fw-bold">
                                            <app-skeleton-loader
                                              [config]="skeletonTheme"
                                            ></app-skeleton-loader>
                                          </span>
                                        </div>
                                      </div>
                                      <div class="row gx-2 mb-1">
                                        <div class="col-3 text-end">DOB</div>
                                        <div class="col-9">
                                          <span class="fw-bold">
                                            <app-skeleton-loader
                                              [config]="skeletonTheme"
                                            ></app-skeleton-loader>
                                          </span>
                                        </div>
                                      </div>
                                      <div class="row gx-2 mb-1">
                                        <div class="col-3 text-end">Email</div>
                                        <div class="col-9">
                                          <span class="fw-bold text-nowrap">
                                            <app-skeleton-loader
                                              [config]="skeletonTheme"
                                            ></app-skeleton-loader>
                                          </span>
                                        </div>
                                      </div>
                                      <div class="row gx-2 mb-1">
                                        <div class="col-3 text-end">Mobile</div>
                                        <div class="col-9">
                                          <span class="fw-bold">
                                            <app-skeleton-loader
                                              [config]="skeletonTheme"
                                            ></app-skeleton-loader>
                                          </span>
                                        </div>
                                      </div>
                                      <div class="row gx-2 mb-1">
                                        <div class="col-3 text-end">Address</div>
                                        <div class="col-9">
                                          <span class="fw-bold">
                                            <app-skeleton-loader
                                              [config]="skeletonTheme"
                                            ></app-skeleton-loader> </span
                                            ><br />
                                            <span class="fw-bold">
                                              <app-skeleton-loader
                                                [config]="skeletonTheme"
                                              ></app-skeleton-loader>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-sm-12 col-xs-12 col-lg-4 p-0">
                                      <div class="d-flex flex-column">
                                        <div class="row gx-2 mb-1">
                                          <div class="col-3 text-end">Status</div>
                                          <div class="col-9">
                                            <span class="fw-bold"
                                              ><app-skeleton-loader
                                              [config]="skeletonTheme"
                                              ></app-skeleton-loader
                                            ></span>
                                          </div>
                                        </div>
                                        <div class="row gx-2 mb-1">
                                          <div class="col-3 text-end">Device Name</div>
                                          <div class="col-9">
                                            <span class="fw-bold"
                                              ><app-skeleton-loader
                                              [config]="skeletonTheme"
                                              ></app-skeleton-loader
                                            ></span>
                                          </div>
                                        </div>
                                        <div class="row gx-2 mb-1">
                                          <div class="col-3 text-end">Associated Phone</div>
                                          <div class="col-9">
                                            <span class="fw-bold"
                                              ><app-skeleton-loader
                                              [config]="skeletonTheme"
                                              ></app-skeleton-loader
                                            ></span>
                                          </div>
                                        </div>
                                        <div class="row gx-2 mb-1">
                                          <div class="col-3 text-end">Model/Serial No.</div>
                                          <div class="col-9">
                                            <span class="fw-bold"
                                              ><app-skeleton-loader
                                              [config]="skeletonTheme"
                                              ></app-skeleton-loader
                                            ></span>
                                          </div>
                                        </div>
                                        <div class="row gx-2 mb-1">
                                          <div class="col-3 text-end">IMEI</div>
                                          <div class="col-9">
                                            <span class="fw-bold"
                                              ><app-skeleton-loader
                                              [config]="skeletonTheme"
                                              ></app-skeleton-loader
                                            ></span>
                                          </div>
                                        </div>
                                        <div class="row gx-2 mb-1">
                                          <div class="col-3 text-end">Watch App Version</div>
                                          <div class="col-9">
                                            <span class="fw-bold"
                                              ><app-skeleton-loader
                                              [config]="skeletonTheme"
                                              ></app-skeleton-loader
                                            ></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-2"></div>
                                  }
                                </div>
                              </div>
                            </div>

                            <!--  threat pairs section -->
                            @if (user?.threatPairs?.length > 0) {
                              <div class="mb-2">
                                <mdb-accordion [multiple]="true" class="accordion-block">
                                  <mdb-accordion-item [collapsed]="false">
                                    <ng-template mdbAccordionItemHeader>
                                      <div class="d-flex w-100 align-items-center justify-content-between gap-2 pe-1">
                                        <span class="d-flex align-items-center gap-2 flex-wrap">
                                          <i-bs name="people-fill" class="text-primary-dark"></i-bs>
                                          <span class="fw-bold">Threat Pairs</span>
                                          <span class="badge rounded-pill bg-primary">{{ this.user?.threatPairs?.length ?? 0 }}</span>
                                        </span>
                                      </div>
                                    </ng-template>
                                    <ng-template mdbAccordionItemBody>
                                      <div class="scrollbar-primary thin overflow-auto table-responsive">
                                        <table class="table align-middle mb-0">
                                          <thead class="bg-gray-light text-gray-dark">
                                            <tr>
                                              <th>{{user?.userType === endUserTypeList.Perpetrator ? 'Survivor' : 'Perpetrator'}}</th>
                                              <th>Alert radius</th>
                                              <th>Status</th>
                                              <th>Last Alert</th>
                                              <th class="text-end"></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            @if (this.user?.threatPairs?.length === 0) {
                                              <tr>
                                                <td colspan="5" class="text-center py-5 text-muted">
                                                  <i-bs name="journal-text" width="2rem" height="2rem"></i-bs>
                                                  <p class="mt-2 mb-0">
                                                    {{ survivorThreatPairsEmptyMessage }}
                                                  </p>
                                                </td>
                                              </tr>
                                            }
                                            @for (pair of this.user?.threatPairs; track pair) {
                                              <tr>
                                                <td>
                                                  <div class="d-flex align-items-center gap-1">
                                                    <span
                                                      class="nav-link avatar avatar-sm p-0 text-center text-white fw-bold"
                                                      [ngClass]="user?.userType === endUserTypeList.Perpetrator ? 'bg-primary-dark' :'bg-primary-darker'"
                                                      >
                                                      {{ user?.userType === endUserTypeList.Perpetrator ? pair?.survivor?.initials : pair?.perpetrator?.initials }}
                                                    </span>
                                                    <div class="d-flex flex-column gap-0.5">
                                                      <span class="fw-bold">{{ user?.userType === endUserTypeList.Perpetrator ? pair?.survivor?.name : pair?.perpetrator?.name }}</span>
                                                      <span
                                                        class="badge rounded-pill bg-opacity-10 bg-info text-info align-self-start"
                                                        >{{ user?.userType === endUserTypeList.Perpetrator ? pair?.perpetrator?.organization?.name : pair?.survivor?.organization?.name }}</span
                                                        >
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="d-inline-flex align-items-center small fw-medium rounded-3 border border-warning border-opacity-50 text-warning bg-warning bg-opacity-10 px-2"
                                                      >
                                                      <i class="fas fa-map-marker-alt me-1"></i>
                                                      {{ pair.distanceThreshold || 0 }} m
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      class="d-inline-flex align-items-center gap-1 small fw-medium"
                      [ngClass]="
                        pair.status.toLowerCase() === 'active'
                          ? 'text-success'
                          : 'text-secondary'
                      "
                                                      >
                                                      <span
                                                        class="rounded-circle flex-shrink-0 d-inline-block"
                        [ngClass]="
                          pair.status.toLowerCase() === 'active'
                            ? 'bg-success'
                            : 'bg-secondary'
                        "
                                                        [style.width.px]="8"
                                                        [style.height.px]="8"
                                                      ></span>
                                                      {{ pair.status | titlecase }}
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <div class="d-flex flex-column gap-1">
                                                      <span class="fw-medium text-dark">{{
                                                        pair.lastAlertDate ?? '-'
                                                      }}</span>
                                                      @if (pair.lastAlertDistance) {
                                                        <span
                                                          class="small text-muted d-inline-flex align-items-center"
                                                          >
                                                          <i-bs
                                                            name="exclamation-triangle-fill"
                                                            class="text-danger flex-shrink-0 me-1"
                                                          ></i-bs>
                                                          {{ pair.lastAlertDistance }} detected
                                                        </span>
                                                      }
                                                    </div>
                                                  </td>
                                                  <td class="text-end">
                                                    <div class="d-flex gap-1 justify-content-end flex-wrap">
                                                      <!-- @if (canViewAxisLinkLiveMap) {
                                                        <button
                                                          type="button"
                                                          class="btn btn-sm border-0 rounded-2 text-primary-darker bg-primary-lighter border-primary-darker fw-bold"
                                                          (click)="onThreatPairLiveMap(pair)"
                                                          aria-label="Open live map"
                                                          [mdbTooltip]="'Live Map'"
                                                          >
                                                          <i-bs name="map-fill"></i-bs>
                                                        </button>
                                                      } -->
                                                      <button
                                                        type="button"
                                                        class="btn btn-sm border-0 rounded-2 text-danger-darker bg-primary-lighter border-danger-darker fw-bold"
                                                        (click)="onThreatPairAlerts(pair)"
                                                        >
                                                        <i-bs name="bell" class="me-1"></i-bs>
                                                        Alerts
                                                      </button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              }
                                            </tbody>
                                          </table>
                                        </div>
                                      </ng-template>
                                    </mdb-accordion-item>
                                  </mdb-accordion>
                                </div>
                              }
                              <!-- end threat pairs section -->

                              <!-- Advocate Assist Dashboard -->
                              <div class="mb-2">
                                <mdb-accordion [multiple]="false" class="accordion-block">
                                  <mdb-accordion-item [collapsed]="true">
                                    <ng-template mdbAccordionItemHeader>Emergency Details</ng-template>
                                    <ng-template mdbAccordionItemBody>
                                      <div class="row g-3" [style.height]="'350px'">
                                        <div [ngClass]="!isLoggedInEndUser ? 'col-lg-6' : 'col-lg-9'">
                                          <div class="p-2 border rounded h-100">
                                            <p class="fw-bold">Emergency Event Map/Tracking</p>
                                            <div class="row">
                                              <div class="col-8">
                                                @if (mapFeatures) {
                                                  <app-google-map
                                                    [height]="'260px'"
                                                    [features]="mapFeatures"
                                                    [customMarkers]="emergencyTriggeredLocations"
                                                  ></app-google-map>
                                                }
                                              </div>
                                              <div class="col-4 d-flex align-items-center">
                                                <table>
                                                  @for (constant of mapConstants; track constant) {
                                                    <tr
                                                      class="map-legends"
                                                      >
                                                      <td
                                                        class="text-center"
                                                        [style.width]="'25px'"
                                                        [innerHTML]="constant.icon"
                                                      ></td>
                                                      <td>
                                                        <small class="fw-bold">{{ constant.label }}</small>
                                                      </td>
                                                    </tr>
                                                  }
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-lg-3">
                                          <div
                                            class="p-2 border rounded d-flex flex-column justify-content-between h-100"
                                            >
                                            <div class="blurred">
                                              <!--<p class="fw-bold">Event Recordings</p>
                                              <small class="mb-1 fw-bold"
                                                ><i class="fas fa-headphones"></i>&nbsp; Dispatch
                                                Recordings</small
                                                >
                                                <ul
                                                  class="my-1 scrollbar-primary thin overflow-auto"
                                                  style="list-style-type: none; height: '170px'"
                                                  >
                                                  <li *ngFor="let recording of recordings">
                                                    <a href="#"
                                                      ><small
                                                      ><i class="fas fa-play"></i>&nbsp;
                                                      {{ recording?.name }}</small
                                                      ></a
                                                      >
                                                    </li>
                                                  </ul>-->
                                                </div>
                                                <div class="d-flex flex-column">
                                                  <button
                                                    class="btn btn-light bg-white border"
                                                    (click)="onRequestRecording()"
                                                    >
                                                    <small class="blue">Request Audio Recording</small>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            @if (!isLoggedInEndUser) {
                                            <div class="col-lg-3">
                                              <div class="p-2 border rounded h-100">
                                                <p class="fw-bold">Case Information</p>
                                                <div class="mb-2">
                                                  <table>
                                                    <tr>
                                                      <td [style.width]="'25px'">
                                                        <small><i class="fas fa-money-check"></i></small>
                                                      </td>
                                                      <td>
                                                        <small class="fw-bold">Account Number</small>
                                                        <!-- <i
                        *ngIf="
                          !user?.rapidSynced && !isLoading.syncAccountNumber
                        "
                                                        class="fas fa-sync ms-1 text-danger"
                                                        style="cursor: pointer"
                                                        [mdbTooltip]="'Sync with Rapid Web'"
                                                        (click)="onSyncAccountNumberInRapid()"
                                                      ></i> -->
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td></td>
                                                    <td>
                                                      <small>{{ user?.accountNumber }}</small>
                                                      @if (isLoading.syncAccountNumber) {
                                                        <span
                                                          class="spinner-grow spinner-grow-sm ms-1"
                                                          role="status"
                                                          aria-hidden="true"
                                                        ></span>
                                                      }
                                                    </td>
                                                  </tr>
                                                </table>
                                              </div>
                                              <div class="d-flex flex-column gap-2">
                                                <!-- <p class="fw-bold">RRMS - Mock Test</p> -->
                                                <div class="d-flex flex-column shadow-sm p-2">
                                                  <!-- <button class="btn btn-primary mb-2" (click)="onEmergencyClear()">
                                                  <small>Emergency Clear</small>
                                                </button> -->
                                                <button
                                                  class="btn btn-primary"
                                                  (click)="onDownloadRRMSLogs()"
                                                  >
                                                  <small>Download RRMS Logs</small>
                                                </button>
                                              </div>
                                              @if (user?.status?.toLowerCase() === 'activated' && user?.rapidSynced) {
                                                <div class="shadow-sm p-2">
                                                  @if (testEndTime && currentTime !== testEndTime) {
                                                    <div>
                                                      <div class="d-flex flex-column">
                                                        <button
                                                          class="btn btn-primary"
                                                          (click)="onStopTest()"
                                                          [disabled]="isLoading.testAction"
                                                          >
                                                          <small>Stop Test</small>
                                                        </button>
                                                      </div>
                                                      <div class="d-flex flex-column gap-2 justify-content-between align-items-center pt-2">
                                                        <p class="test-font">The test ends at <b>{{ testEndTime }}</b></p>
                                                      </div>
                                                    </div>
                                                  } @else {
                                                    <div class="d-flex flex-column">
                                                      <button
                                                        class="btn btn-primary"
                                                        (click)="onCountdownActionClick('start')"
                                                        [disabled]="isLoading.testAction"
                                                        >
                                                        <small>Begin Test</small>
                                                      </button>
                                                    </div>
                                                  }
                                                </div>
                                              }
                                            </div>

                                            <!-- <div class="mb-2">
                                            <table>
                                              <tr>
                                                <td [style.width]="'25px'">
                                                  <small><i class="fas fa-user"></i></small>
                                                </td>
                                                <td>
                                                  <small class="fw-bold">Dependant/Perpetrator</small>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td></td>
                                                <td><small>John Q. Smith</small></td>
                                              </tr>
                                            </table>
                                          </div>
                                          <div class="mb-2">
                                            <table>
                                              <tr>
                                                <td [style.width]="'25px'"><i class="fas fa-home"></i></td>
                                                <td>
                                                  <small class="fw-bold">Home/Housing Details</small><br />
                                                </td>
                                              </tr>
                                              <tr>
                                                <td></td>
                                                <td>
                                                  <small>1234 Main Street</small><br />
                                                  <small>Anytown, USA</small><br />
                                                </td>
                                              </tr>
                                            </table>
                                          </div>
                                          <div class="mb-2">
                                            <table>
                                              <tr>
                                                <td [style.width]="'25px'"><i class="fas fa-users"></i></td>
                                                <td><small class="fw-bold">Family Information</small></td>
                                              </tr>
                                              <tr>
                                                <td></td>
                                                <td>
                                                  <small>Jane P. Smith (Mother)</small><br />
                                                  <small>Jim P. Smith (Father)</small>
                                                </td>
                                              </tr>
                                            </table>
                                          </div> -->
                                        </div>
                                      </div>
                                      }
                                    </div>
                                  </ng-template>
                                </mdb-accordion-item>
                              </mdb-accordion>
                            </div>
                            <!-- Advocate Assist Dashboard -->

                            <div class="d-flex justify-content-end mb-3">
                              <form [formGroup]="userDetailForm" autocomplete="off">
                                <!-- <app-search></app-search> -->
                                <div class="d-flex align-items-end">
                                  <!-- <button
                                  class="btn btn-gray-light btn-md avatar d-flex align-items-center justify-content-center me-2"
                                  [disabled]="loading"
                                  (click)="getFiltered(true)">
                                  <i class="fas fa-redo"></i>
                                </button> -->
                                <div class="me-2">
                                  <label for="From" class="form-label">Created From</label>
                                  <mdb-form-control>
                                    <div class="datepicker-wrapper">
                                      <input
                                        [readonly]="true"
                                        mdbInput
                                        [mdbDatepicker]="createdFrom"
                                        type="text"
                                        class="form-control"
                                        id="createdFrom"
                                        formControlName="createdFrom"
                                        />
                                      @if (userDetailForm.value.createdFrom) {
                                        <button
                                          class="datepicker-clear-button"
                                          (click)="clearDatePicked('createdFrom')"
                                          >
                                          <i class="fas fa-times"></i>
                                        </button>
                                      }
                                      <mdb-datepicker-toggle
                                        [mdbDatepicker]="createdFrom"
                                      ></mdb-datepicker-toggle>
                                      <mdb-datepicker
                                        [inline]="true"
                                        [format]="mdbDateFormat"
                                        [maxDate]="getMaxDate()"
                                        #createdFrom
                                        (dateChanged)="getFiltered(true, true)"
                                      ></mdb-datepicker>
                                    </div>
                                  </mdb-form-control>
                                </div>
                                <div class="me-2">
                                  <label for="To" class="form-label">Created To</label>
                                  <mdb-form-control>
                                    <div class="datepicker-wrapper">
                                      <input
                                        mdbInput
                                        [readonly]="true"
                                        [mdbDatepicker]="createdTo"
                                        type="text"
                                        class="form-control"
                                        id="createdTo"
                                        formControlName="createdTo"
                                        />
                                      @if (userDetailForm.value.createdTo) {
                                        <button
                                          class="datepicker-clear-button"
                                          (click)="clearDatePicked('createdTo')"
                                          >
                                          <i class="fas fa-times"></i>
                                        </button>
                                      }
                                      <mdb-datepicker-toggle
                                        [mdbDatepicker]="createdTo"
                                      ></mdb-datepicker-toggle>
                                      <mdb-datepicker
                                        [inline]="true"
                                        [format]="mdbDateFormat"
              [minDate]="
                this.userDetailForm.controls['createdFrom'].value &&
                getMinDate()
              "
                                        [maxDate]="getMaxDate()"
                                        #createdTo
                                        (dateChanged)="getFiltered(true, true)"
                                      ></mdb-datepicker>
                                    </div>
                                  </mdb-form-control>
                                </div>
                                <div>
                                  <button
                                    type="button"
                                    class="btn btn-outline-primary"
                                    (click)="openConfigureColumnModal(userColumnData)"
                                    >
                                    <i-bs class="bi bi-sliders">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-sliders"
                                        viewBox="0 0 16 16"
                                        >
                                        <path
                                          fill-rule="evenodd"
                                          d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z"
                                          />
                                      </svg>
                                    </i-bs>
                                    Customize Columns
                                  </button>
                                </div>
                                <!-- <app-select [form]="userDetailForm" [control]="userDetailForm.controls['limit']" [controlName]="'limit'"
                                [filter]="false" [submitted]="submitted" [data]="limits" [name]="'label'" [value]="'value'" [width]="defaultLimitSelectWidth"
                                (emitSelectedValue)="receiveSelectedValue($event)">
                              </app-select> -->
                            </div>
                          </form>
                        </div>

                        <app-table
                          [tableConfig]="tableConfig"
                          [convertToLocal]="user?.watchAppVersion == 2"
                          [module]="'Check in module'"
                          [loading]="loading"
                          [getRowClass]="getActivityRowClass"
                          (onScrollToBottom)="scrollToBottom($event)"
                          [notFoundMessage]="notFoundMessage"
                          (sendEvent)="receiveEvent($event)"
                          >
                        </app-table>
